<template>
	<div style="display: contents;">
		<template v-if="buttonComponent == 'v-btn'">
            <v-tooltip top>
                <template v-slot:activator="{ on: tooltip }">
                    <v-btn
                        v-on="{ ...tooltip }"
						:fab="button.params.fab ? button.params.fab : false"
						:icon="button.params.fab ? false : true"
						:small="button.params.small ? true : false"
						:fixed="button.params.fixed ? true : false"
						:bottom="button.params.bottom ? true : false"
						:right="button.params.right ? true : false"
						:dark="button.params.dark ? true : false"
						:color="button.params.button_color ? button.params.button_color : ''"
						@click="openDialog">
                        <v-icon :size="$vuetify.breakpoint.smAndDown ? 28 : 24" :color="params ? params.color : ''">{{ button.params.icon ? button.params.icon : 'mdi-wrench' }}</v-icon>
					</v-btn>
				</template>
        		<span>{{ 'Modifica Intervento' }}</span>
    		</v-tooltip>
		</template>

		<v-list-item v-else-if="buttonComponent == 'v-list-item'"
			dense 
			:disabled="disabled"
			@click.stop="openDialog()"
			ripple>
			<v-list-item-icon>
				<v-icon style="font-size: 18px">{{ icon }}</v-icon>
			</v-list-item-icon>
			<v-list-item-content>
				<v-list-item-title>{{ tooltipText }}</v-list-item-title>
			</v-list-item-content>

		</v-list-item>

        <v-dialog v-model="show" max-width="900" persistent class="round-card" :fullscreen="fullScreen || $vuetify.breakpoint.smAndDown" scrollable>
            <v-card class="background-2 round-card">
                <v-card-title class="pa-3">
                    <p class="pl-2 pl-xl-3">{{ titleDialog }} Intervento</p>
                    <v-spacer></v-spacer>
                    <v-btn icon @click.native.stop="fullScreen = !fullScreen"><v-icon>fullscreen</v-icon></v-btn>
                </v-card-title>            
                <v-divider></v-divider>
                <v-card-text class="px-1 pb-1">

                    <v-container v-if="show" fluid :class="{'px-3': $vuetify.breakpoint.mdAndUp, 'px-0': $vuetify.breakpoint.smAndDown}" class="pt-6">
                        <fields-generator
                            :fieldsset.sync="fieldsset"
                            :model="intervention"
                            ref="fieldsgenerator"
                            :selectChange="onChange"
                            @loaded="checkDefaultInput"
                        ></fields-generator>
                        <small class="px-4">* Indica i campi obbligatori</small>
                    </v-container>
                    <v-divider></v-divider>

                    <template v-if="show && $store.getters.checkSettings('product_in_trouble')">
                        <intervention-product-list
                            :children="intervention.interventionproducttrouble"
                            :parent="intervention"
                            :id="model.id"
                        ></intervention-product-list>
                        <v-divider></v-divider>
                    </template>

                    <template v-if="show && $store.getters.checkSettings('products_association_intervention')">
                        <crud-table-relationship
                            info-url="interventionproduct-info"
                            :children="intervention.products"
                            :parent="intervention"
                            :in-dialog="true"
                        ></crud-table-relationship>
                        <v-divider></v-divider>
                    </template>

                </v-card-text>

                <v-divider></v-divider>
                
                <v-card-actions style="padding-bottom: calc(16px + env(safe-area-inset-bottom));">
                    <v-spacer></v-spacer>
                    <v-btn text color="info" @click.native.stop="closeDialog()">Annulla
                    </v-btn>
                    <v-btn text color="primary" @click.native.stop="createModel()" :loading="loading">{{ button.params.create ? 'Salva' : 'Modifica'}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>

    import Vue from 'vue'
    import CrudTableRelationship from '@/components/common/CrudTableRelationship'
    import InterventionProductList from '@/components/modules/tickets/InterventionProductList'


    export default {
        name: 'generate-intervention-button',
        components: {
            CrudTableRelationship,
            InterventionProductList,
        },
        props: {
            button: Object,
		    buttonComponent: {type: String, default : 'v-btn'},
            model: Object,
            params: Object,
            disabled: Boolean,
            autoOpen: {type: Boolean, default: false}
        },

        data() {
            return {
                support: {},
                show: false,
                fieldsset: {},
                loading: false,
                intervention: {},
                fullScreen: false,
                confirmExit: false,
            }
        },

        computed: {
            titleDialog() {
                return this.button.params && this.button.params.create ? 'Creazione' : 'Modifica'                
            },

            icon() {
                if (this.button.params && this.button.params.icon) {
                    return this.button.params.icon
                } else {
                    return 'mdi-wrench'
                }
            },
            
            tooltipText() {
                if (this.button.params && this.button.params.tooltip) {
                    return this.button.params.tooltip
                } else {
                    return 'Crea Intervento'
                }
            },
        },

        methods: {

            closeDialog() {
                this.show = false
                this.$emit('close')
            },

            openDialog() {
                this.axios.get('interventions/create').then(response => {
                    // get body data
                    this.fieldsset = response.data.fields

                    // Set defaultInput by back-end
                    if(this.button.params.create) {
                        this.intervention.timecardable_id = this.model.id
                        this.intervention.timecardable_type = 'trouble'
                        this.intervention.products = []

                        _.forEach(this.fieldsset.fields, (value, key) => {
                            if(value.default) {
                                Vue.set(this.intervention, value.key, value.default)
                            }
                        })
    
                    } else {
                        this.intervention = Object.assign(this.intervention, this.model)
                        this.intervention.products = Object.assign(this.intervention.products, this.model.products)
                        this.intervention.timecardable_type = 'trouble'

                        // In edit forza multiple => false per operator_id (si modifica un singolo intervento)
                        let operatorField = this.fieldsset.fields.find(f => f.key === 'operator_id')
                        if (operatorField) {
                            operatorField.multiple = false
                        }
                    }

                    this.show = true

                }, response => {
                    if(this.$store.getters.offlineMode) {
                        //is offline
                        this.intervention = {}
                        let users_options = this.$store.getters.usersSeq.map(user => {
                            return {
                                'id': user.id,
                                'name' : user.value,
                                'avatar': user.avatar
                            }
                        })
                        this.fieldsset = {
                            'model_name': 'intervention',
                            'modelDef': 'interventions',
                            'fields': [
                                {
                                    label: 'Operatore',
                                    type: 'belongsTo',
                                    item_text: 'name',
                                    item_value: 'id',
                                    key: 'operator_id',
                                    chips: true,
                                    default: this.$store.getters.getUserId,
                                    required: true,
                                    validations: 'required',
                                    multiple: false,
                                    options: users_options,
                                },
                                {
                                    label: 'Responsabile',
                                    type: 'belongsTo',
                                    item_text: 'name',
                                    item_value: 'id',
                                    key: 'owner_id',
                                    chips: true,
                                    default: this.$store.getters.getUserId,
                                    required: true,
                                    validations: 'required',
                                    multiple: false,
                                    options: users_options,
                                },
                                {
                                    label: 'Data di Inizio',
                                    type: 'date',
                                    key: 'start_date',
                                    required: true,
                                    validations: 'required',
                                    default: moment().format('YYYY-MM-DD'),
                                },
                                {
                                    label: 'Data di Fine',
                                    type: 'date',
                                    key: 'end_date',
                                    required: true,
                                    validations: 'required',
                                    default: moment().format('YYYY-MM-DD'),
                                },
                                {
                                    label: 'Ora di Inizio',
                                    type: 'text-mask',
                                    key: 'start_time',
                                    default: moment().format('HH:mm'),
                                    mask: '##:##',
                                    required: true,
                                    returnMaskedValue: true,
                                    validations: 'required|is_time',
                                },
                                {
                                    label: 'Ora di Fine',
                                    type: 'text-mask',
                                    key: 'end_time',
                                    default: moment().format('HH:mm'),
                                    mask: '##:##',
                                    required: true,
                                    returnMaskedValue: true,
                                    validations: 'required|is_time',
                                },
                                {
                                    label: 'Descrizione',
                                    type: 'text-editor',
                                    key: 'description',
                                    class: 'd-block col-12 px-6 pt-2'
                                },
                                {
                                    label: 'Note interne',
                                    type: 'text-editor',
                                    key: 'internal_notes',
                                    class: 'd-block col-12 px-6 pt-2',
                                },
                            ]
                        }

                        // Set defaultInput by back-end
                        _.forEach(this.fieldsset.fields, (value, key) => {
                            if(value.default) {
                                Vue.set(this.intervention, value.key, value.default)
                            }
                        })

                        if(this.button.params.edit) {
                            this.intervention = Object.assign(this.intervention, this.model)
                            this.intervention.timecardable_type = 'trouble'

                            var db = this.$store.getters.getDB
                            Vue.set(this.intervention, 'products', [])
                            db.interventionproduct.where('intervention_id').equals(this.intervention.id).toArray().then(products => {
                                this.intervention.products = Object.assign(this.intervention.products, products)
                                this.show = true
                            })
                        } else {
                            Vue.set(this.intervention, 'products', [])
                            this.show = true
                        }
                    } else {
                        this.$store.commit('setSnackbarError')
                    }

                })
            },

            // Call at change select option
            onChange(field, event) {
                Promise.all(this.$eventBusUtility.fieldsGeneratorConditions(field, event, this.fieldsset, this.intervention, this.support, this.defaultInput)).then((responses) => {
                    responses.forEach(response => {
                        if(this.intervention[response.key]) {
                            this.$refs.fieldsgenerator.$refs[response.key][0].$emit('change', this.intervention[response.key])
                        }
                    })
                })
            },

            //model is trouble
            createModel() {
                this.confirmExit = false

                this.$refs.fieldsgenerator.$validator.validateAll().then(result => {
                    if (!result) {
                        return this.handleValidationErrorAdvanced()
                    }

                    // Il backend non valida e salverebbe una duration_minutes in valore assoluto.
                    const startMoment = moment(this.intervention.start_date + ' ' + this.intervention.start_time, 'YYYY-MM-DD HH:mm')
                    const endMoment = moment(this.intervention.end_date + ' ' + this.intervention.end_time, 'YYYY-MM-DD HH:mm')
                    if (startMoment.isValid() && endMoment.isValid() && endMoment.isBefore(startMoment)) {
                        return this.$store.commit('setSnackbar', {
                            timeout: 6000,
                            text: "L'orario di fine è precedente a quello di inizio: correggi date e ore",
                            value: true,
                            color: 'error'
                        })
                    }

                    if(this.button.params.create) {
                        this.loading = true

                        this.axios.post('interventions', this.intervention).then(response => {
                            // get body data
                            this.intervention = {}
                            this.$store.commit('setModelEdited', false)
                            this.$eventBusUtility.$emit('updateTroubleShow')
                            this.show = false
                            this.loading = false

                        }, response => {
                            if(this.$store.getters.offlineMode) {
                                this.intervention.owner = this.$store.getters.users[this.intervention.owner_id].value
                                this.intervention.operator = this.$store.getters.users[this.intervention.operator_id].value
                                this.intervention.creator = this.$store.getters.users[this.$store.getters.getUserId].value
                                this.intervention.timecardable_id = this.model.id
                                this.intervention.timecardable_type = 'trouble'
                                this.intervention.offline = moment().format('X')
                                this.intervention.create = true

                                this.intervention.duration_minutes = moment.duration(moment(this.intervention.end_date + ' ' + this.intervention.end_time, 'YYYY-MM-DD HH:mm').diff(moment(this.intervention.start_date + ' ' + this.intervention.start_time, 'YYYY-MM-DD HH:mm'))).asMinutes()

                                var db = this.$store.getters.getDB
                                _.forEach(this.intervention.products, (product, key) => {
                                    this.intervention.products[key].offline = moment().format('X')
                                    this.intervention.products[key].create = true
                                    // take product name in products table
                                    db.products.where('id').equals(product.product_id).first(prod => {
                                        this.intervention.products[key].name = prod.name
                                    })
                                })

                                let setIntervention = new Promise((resolve, reject) => {
                                    resolve(
                                        db.interventions.put(this.intervention).then(intervention_id => {
                                            
                                            _.forEach(this.intervention.products, (product, key) => {
                                                delete product.id
                                                product.intervention_id = intervention_id
                                                db.interventionproduct.put(product).then(result => {
                                                    // console.log('prodotto inserito')
                                                })
                                            })

                                            this.$store.commit('setSnackbar', {timeout: 6000, text: 'Intervento Aggiunto', value: true, color: 'success'})
                                            this.show = false
                                        }).catch(result => {
                                            this.$store.commit('setSnackbar', {timeout: 6000, text: 'Errore creazione Intervento', value: true, color: 'error'})
                                        })
                                    )
                                })

                                setIntervention.then(() => {
                                    this.intervention = Object.assign(this.intervention, {})
                                    this.$eventBusUtility.$emit('updateTroubleShow')
                                })
                                this.loading = false
                            } else {
                                this.$store.commit('setSnackbarError')
                            }
                        })
                    } else {
                        // is in edit
                        this.loading = true
                        this.axios.put('interventions/' + this.intervention.id, this.intervention).then(response => {
                            // get body data
                            this.$store.commit('setModelEdited', false)
                            this.$eventBusUtility.$emit('updateTroubleShow')
                            this.show = false
                            this.loading = false

                        }, response => {

                            if(this.$store.getters.offlineMode) {
                                this.intervention.offline = moment().format('X')
                                this.intervention.edit = true
                                this.intervention.duration_minutes = moment.duration(moment(this.intervention.end_date + ' ' + this.intervention.end_time, 'YYYY-MM-DD HH:mm').diff(moment(this.intervention.start_date + ' ' + this.intervention.start_time, 'YYYY-MM-DD HH:mm'))).asMinutes()

                                var db = this.$store.getters.getDB
                                let formatProducts = new Promise((resolve, reject) => {
                                    resolve(
                                        _.forEach(this.intervention.products, (product, key) => {
                                            this.intervention.products[key].offline = moment().format('X')
                                            this.intervention.products[key].intervention_id = this.intervention.id

                                            db.products.where('id').equals(product.product_id).first(prod => {
                                                this.intervention.products[key].name = prod.name
                                            })

                                            // if product is new
                                            if(this.intervention.products[key].id <= 0) {
                                                delete product.id
                                                this.intervention.products[key].create = true
                                            } else {
                                                // else product is edit
                                                this.intervention.products[key].edit = true
                                            }
                                        })
                                    )
                                })

                                let setIntervention = new Promise((resolve, reject) => {
                                    resolve(
                                        db.interventions.put(this.intervention).then(intervention_id => {
                                            
                                            _.forEach(this.intervention.products, (product, key) => {
                                                product.intervention_id = intervention_id
                                                db.interventionproduct.put(product).then(result => {
                                                    // console.log('prodotto inserito')
                                                })
                                            })                                            
                                            
                                            if(intervention_id) {
                                                this.$store.commit('setSnackbar', {timeout: 6000, text: 'Intervento Modificato', value: true, color: 'success'})
                                            } else {
                                                this.$store.commit('setSnackbar', {timeout: 6000, text: 'Errore Modifica Intervento', value: true, color: 'error'})
                                            }
                                            this.show = false
                                        })
                                    )
                                })
                                formatProducts.then(() => {
                                    setIntervention.then(() => {
                                        this.$eventBusUtility.$emit('updateTroubleShow')
                                    })
                                })
                                this.loading = false
                            } else {
                                this.$store.commit('setSnackbarError')
                            }
                        })
                    }
                }).catch(() => {

                })
            },

            checkDefaultInput() {
                 _.forEach(this.defaultInput, (value, key) => {
                    Vue.set(this.intervention, key, value)
                    if(typeof this.$refs.fieldsgenerator.$refs[key] !== 'undefined') {
                        this.$refs.fieldsgenerator.$refs[key][0].$emit('change', [value])
                    }
                })
            },
        },

        mounted() {
            if (this.autoOpen) {
                this.openDialog()
            }
        }
    }
</script>